import type { ReactNode } from 'react';
import { motion } from 'framer-motion';

import { cn } from '#/lib/utils';

import { defaultMotionProps } from '../motion';
import { StatsCard } from './StatsCard';

export interface Stat {
  stat: string;
  caption: string;
  content: string;
  statClassName?: string;
  contentClassName?: string;
}

export interface StatsClassNames {
  container?: string;
  stat?: string;
  caption?: string;
}

interface StatsSectionProps {
  stats: Stat[];
  className: string;
  statsClassNames: StatsClassNames;
  statsHeading: ReactNode;
  statsIntro: string;
}

export const StatsSection = ({
  stats,
  className,
  statsClassNames,
  statsHeading,
  statsIntro,
}: StatsSectionProps) => {
  return (
    <section className={cn(className, 'relative')}>
      <div className="max-w-[1460px] p-main relative mx-auto grid ml:grid-cols-2 gap-40 py-60 ml:py-150">
        <motion.div
          className="max-w-[280px] ml:max-w-[570px] ml:sticky ml:top-100 self-start"
          {...defaultMotionProps}
        >
          <h2 className="ml:text-[65px] text-[32px] font-normal leading-[94%] tracking-[-0.65px]">
            {statsHeading}
          </h2>
          <p className="ml:text-[21px] text-[16px] font-light leading-[136%] ml:mt-20 mt-16">
            {statsIntro}
          </p>
        </motion.div>
        <div className="flex gap-16 ml:gap-24 flex-col">
          {stats.map(
            ({ stat, caption, content, statClassName, contentClassName }) => (
              <StatsCard
                key={stat}
                contentClassName={contentClassName}
                className={statsClassNames.container}
                captionClassName={statsClassNames.caption}
                statClassName={cn(statsClassNames.stat, statClassName)}
                stat={stat}
                caption={caption}
                content={content}
              />
            ),
          )}
        </div>
      </div>
    </section>
  );
};
